import script from "./CompanyInformationFormLocked.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyInformationFormLocked.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyInformationFormLocked.vue?vue&type=style&index=0&id=bd116384&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd116384"]])

export default __exports__